import { render, staticRenderFns } from "./TabVisitsList.vue?vue&type=template&id=1a91f45c&scoped=true&"
import script from "./TabVisitsList.vue?vue&type=script&lang=js&"
export * from "./TabVisitsList.vue?vue&type=script&lang=js&"
import style0 from "./TabVisitsList.vue?vue&type=style&index=0&id=1a91f45c&lang=scss&scoped=true&"
import style1 from "./TabVisitsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a91f45c",
  null
  
)

export default component.exports